import React from "react";
import { AvatarPixel } from "@/components/ui/avatar";
import { useContext } from "react";
import { UserContext } from "@/components/context";
import { IUser } from "@/lib/types";
import { SignOut } from "@phosphor-icons/react";
import { useMsal } from "@azure/msal-react";
import { signout } from "@/lib/sso";

export const User = () => {
    const { user } = useContext(UserContext);
    const { instance, accounts } = useMsal();

    const handleSignout = async () => {
        await signout(instance, accounts[0]);
    };

    return (
        <>
            {user && (
                <div className={"flex-none pb-2 lg:pb-8 px-4 mb-0.5"}>
                    <div className={"flex flex-row items-center"}>
                        <div className={"flex-none mr-2.5"}>
                            <div className={"relative w-[32px] h-[32px]"}>
                                <AvatarPixel
                                    name={(user as IUser).name}
                                    colors={["#5570af", "#146A7C", "#b37a20", "#88417c", "#C20D90"]}
                                    size={32}
                                    square={false}
                                    title={(user as IUser).name}
                                />
                                <div className="absolute w-full h-full left-0 top-0 text-xl text-zinc-50 shadow-sm font-black text-center">
                                    {user ? user.name.charAt(0) : ""}
                                </div>
                            </div>
                        </div>

                        <div className={"flex-1 w-full overflow-hidden flex flex-col"}>
                            <div className={"flex-none truncate font-bold"}>
                                {user ? user.name : ""}
                            </div>
                            <div className={"flex-none inline-flex flex-row items-center"}>
                                <div
                                    className={"flex-none inline-flex group cursor-pointer"}
                                    onClick={handleSignout}
                                >
                                    <div className={"inline-block"}>
                                        <SignOut size={18} className={"translate-y-[2px]"} />
                                    </div>
                                    <div
                                        className={
                                            "text-sm inline-block flex-none px-1 group-hover:underline"
                                        }
                                    >
                                        Sign out
                                    </div>
                                </div>
                                <div className={"flex-1"}>&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
